interface IDevMode {
  isAppMode: boolean;
  isMarketingMode: boolean;
}

/**
 * @returns The current development mode. Will return undefined if the MODE environment variable is not set. Neither flags will be true if the MODE environment variable is not set.
 */
export const getDevMode = (): IDevMode | undefined => {
  const devMode = import.meta.env.VITE_APP_MODE;

  console.log(`%cthis is the import.meta.env:`, 'background:#ffd040; color:#222;', import.meta.env);

  console.log(`%cthis is the devMode:`, 'background:#bada55; color:#222;', devMode);
  return devMode
    ? {
        isAppMode: devMode === 'app',
        isMarketingMode: devMode === 'marketing',
      }
    : undefined;
};
